import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaStar } from 'react-icons/fa';

const Testimonials = ({ currentTheme }) => {
  const testimonials = [
    {
      name: "Sir Ngugi",
      position: "CEO, APBC Africa",
      desc: "I had the pleasure of working with Sylvester as a software developer. His dedication and expertise were invaluable to our team."
    },
    {
      name: "Elliot Embler",
      position: "Project Manager",
      desc: "Sylvester provided exceptional technical documentation services, ensuring our project's success through clear and concise documentation."
    },
    {
      name: "Umeko Evans",
      position: "Design Lead",
      desc: "Sylvester's UI/UX design and frontend development skills were instrumental in creating a user-friendly and visually appealing interface for our application."
    },
    {
      name: "Julius Opuoyo",
      position: "Research Director",
      desc: "I was impressed by Sylvester's research writing skills, which significantly contributed to the quality and depth of our research publications."
    }
  ];

  return (
    <Container fluid className="py-5 position-relative overflow-hidden" id='testimonials' style={{ backgroundColor: currentTheme.background }}>
      <div className="position-absolute w-100 h-100 top-0 start-0" style={{ zIndex: -1 }}>
        <motion.div
          animate={{
            background: [
              `linear-gradient(45deg, ${currentTheme.primary} 0%, ${currentTheme.secondary} 100%)`,
              `linear-gradient(45deg, ${currentTheme.secondary} 0%, ${currentTheme.primary} 100%)`
            ],
          }}
          transition={{ duration: 3, repeat: Infinity, repeatType: 'reverse' }}
          className="w-100 h-100"
        />
      </div>

      <Container className="position-relative">
        <motion.div
          className="text-center mb-5"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <motion.div
            animate={{
              y: [-5, 5, -5],
              transition: { duration: 2, repeat: Infinity }
            }}
            className="mb-3"
          >
            <FaStar style={{ color: currentTheme.primary }} className="display-1" />
          </motion.div>
          <h2 className="display-4 fw-bold mb-1" style={{ color: currentTheme.primary }}>TESTIMONIALS</h2>
          <div className="d-flex align-items-center justify-content-center gap-2 mb-4">
            <div style={{ backgroundColor: currentTheme.primary, height: '2px', width: '30px' }}></div>
            <FaStar style={{ color: currentTheme.primary }} />
            <div style={{ backgroundColor: currentTheme.primary, height: '2px', width: '30px' }}></div>
          </div>
        </motion.div>

        <Row className="row-cols-1 row-cols-md-2 g-4">
          {testimonials.map((testimonial, index) => (
            <Col key={index}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="p-4 rounded shadow-sm mb-4"
                style={{ 
                  backgroundColor: currentTheme.background === '#121212' ? '#222222' : 'rgba(255, 255, 255, 0.9)',
                  borderColor: currentTheme.primary,
                  borderWidth: '1px',
                  borderStyle: 'solid'
                }}
              >
                <div className="d-flex align-items-center mb-3">
                  <div style={{ backgroundColor: `rgba(${currentTheme.primary}, 0.1)` }} className="p-3 rounded-circle me-3">
                    <FaStar style={{ color: currentTheme.primary }} />
                  </div>
                  <div>
                    <h5 className="fw-bold mb-1 fs-5 lh-base" style={{ color: currentTheme.text }}>{testimonial.name}</h5>
                    <p className="fs-6 lh-base" style={{ color: currentTheme.text }}>{testimonial.position}</p>
                  </div>
                </div>
                <p className="fs-6 lh-base mb-0" style={{ color: currentTheme.text }}>{testimonial.desc}</p>
              </motion.div>
            </Col>
          ))}
        </Row>

        <motion.div
          animate={{
            rotate: 360,
            transition: { duration: 20, repeat: Infinity, ease: "linear" }
          }}
          className="position-absolute"
          style={{ top: '10%', right: '5%', opacity: 0.1 }}
        >
          <FaStar style={{ fontSize: '4rem', color: currentTheme.primary }} />
        </motion.div>
      </Container>
    </Container>
  );
};

export default Testimonials;